import { DownloadIcon, PauseIcon, PlayIcon } from 'lucide-react';
import type { ReactElement } from 'react';

import { Button } from '@/components/ui/button';

interface PodcastActionsProps {
  isPlaying: boolean;
  onTogglePlay: () => void;
  onDownload?: () => void;
}

export function PodcastActions({
  isPlaying,
  onTogglePlay,
  onDownload,
}: PodcastActionsProps): ReactElement {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        size="sm"
        variant="default"
        aria-label={isPlaying ? 'Pausar' : 'Reproduzir'}
        aria-pressed={isPlaying}
        onClick={onTogglePlay}
        className="rounded-full"
      >
        {isPlaying ? <PauseIcon aria-hidden /> : <PlayIcon aria-hidden />}
        {isPlaying ? 'Pausar' : 'Reproduzir'}
      </Button>

      {onDownload && (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          aria-label="Baixar podcast"
          onClick={onDownload}
          className="rounded-full"
        >
          <DownloadIcon aria-hidden />
          Baixar
        </Button>
      )}
    </div>
  );
}
